<template>
  <div class="brand_main">
    <div class="othen_search">
      <!-- 新闻统计 -->
      <div class="news_source">
        <!-- 品牌 -->
        <div class="item_title">品牌：</div>
        <el-select v-model="searchForm.brand" placeholder="请选择" clearable filterable>
          <el-option
            v-for="item in brandOptions"
            :key="item.id"
            :label="item.ZHName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 时间 -->
      <div class="news_source date_search">
        <div class="item_title">时间：</div>
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
          placeholder="开始时间"
          v-model="searchForm.startDate"
        ></el-date-picker>
        <span class="to_txt">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsEnd"
          placeholder="结束时间"
          v-model="searchForm.endDate"
        ></el-date-picker>
      </div>
      <!-- Top -->
      <div class="news_source top_change">
        <div class="item_title">Top：</div>
        <el-select v-model="searchForm.top" placeholder="请选择" @change="topSltChange">
          <el-option
            v-for="item in topOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="news_source search_btn">
        <div class="item_submit" @click="searchOnClick">搜索</div>
      </div>
    </div>
    <div class="data_list" v-if="newsData && newsData.length > 0">
      <div class="news" v-for="(item, index) of newsData" :key="index">
        <!-- 品牌logo -->
        <div class="news_img">
          <div class="img_container">
            <img :src="item.logo" @error="defaultImg(item)" />
          </div>
        </div>
        <div class="news_content">
          <!-- 新闻标题 -->
          <div
            class="title text_one_line"
            @click="newContentDetail(item)"
            v-html="item.title"
          >
            {{ item.title }}
          </div>
          <!-- 新闻摘要 -->
          <div class="detail text_two_line" v-html="item.summary">
            {{ item.summary }}
          </div>
          <div>
            <!-- 发布时间 -->
            <div class="other_info">
              <div>
                <span class="item_title">Release time:</span>
                <span class="item_detail color_alone">
                  {{ item.publish }}
                  <!-- <el-divider direction="vertical"></el-divider> -->
                </span>
              </div>
              <!-- 热度排行 -->
              <div v-if="item.author !== null">
                <span class="item_title">Heat ranking:</span>
                <span class="item_detail">
                  No.{{item.topNum}}
                </span>
              </div>
              <!-- 情感 -->
              <div class="judge_btn">
                <span class="show_btn">{{item.emotion}}</span>
              </div>
            </div>
            <div class="other_info">
              <!-- 相同新闻 -->
              <div>
                <span class="item_title same">Same news:</span>
                <span class="item_detail">{{item.sameNewsCount}}</span>
              </div>
              <!-- 发布媒体 -->
              <div class="publish_media">
                <span class="item_title">Publishing media:</span>
                <!-- <span class="item_detail" v-for="(site, idx) of item.siteMapList" :key="idx">{{site.siteEN}}（{{site.countryEN || 'None'}}）</span> -->
                <el-tooltip placement="top-start" effect="dark">
                  <span slot="content" class="tips-content text-tips-content">点击复制</span>
                  <span
                    class="item_detail"
                    v-clipboard:copy="item.siteMapList.map(site => { return `${site.siteEN}：${site.countryEN} `})"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError">
                    <span
                      v-for="(site, idx) in item.siteMapList"
                      :key="idx"
                      >{{ site.siteEN }}（{{ site.countryEN }}）</span>
                  </span>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { overseasPublic, newsID, brandTopStatistics, findCompanyByName } from "@/common/js/http/version3Api.js";
import qs from "qs";
import AbstractList from "@/common/components/AbstractList";
import { Notification } from 'element-ui';
export default {
  mixins: [AbstractList],
  data() {
    return {
      brandOptions: [],
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.searchForm.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.searchForm.startDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      topOptions: [
        {
          value: "10",
          label: "10",
        },
        {
          value: "20",
          label: "20",
        },
        {
          value: "50",
          label: "50",
        }
      ],
      newsData:[],
      searchForm: {
        brand:"",
        startDate:"",
        endDate:"",
        top: 10
      }
    };
  },
  created() {
      this.getBrandOption();
  },
  methods: {
    // 品牌下拉框
    getBrandOption() {
      findCompanyByName('').then(rst => {
        this.brandOptions = rst.result
        if(this.brandOptions.length>0){
          this.searchForm.brand = this.searchForm.brand ? this.searchForm.brand : this.brandOptions[0].id
        }
        this.fetchData();
      }, error => {
        this.fetchData();
      })
    },
    async fetchData() {
      const param = {
        companyId:this.searchForm.brand,
        startTime:this.searchForm.startDate,
        endTime:this.searchForm.endDate,
        top:this.searchForm.top
      }
      const rst =await brandTopStatistics(param);
      if(rst.code === 200) {
        this.newsData = rst.result
      }
    },
    newContentDetail(row) {
      this.$router.push({
        name: "NewsDetail",
        query: {
          isBack: false,
          id: row.id,
          companyId: this.searchForm.brand,
          topNum: row.topNum,
          sameNewsCount: row.sameNewsCount
        },
      });
    },
    topSltChange() {
      this.fetchData()
    },
    onCopy(row) {
      Notification.info({
        title: '复制成功',
        message: '已复制到剪贴板,请直接去Ctrl+V粘贴吧',
        duration: 1500
      })
    },
    onError(row) {
      
    }
  }
};
</script>

<style scoped>
.search {
  width: 20%;
  margin-top: 5px;
}

.search >>> .el-input-group__append .el-icon-search {
  font-size: 20px;
  font-weight: bold;
}

.search >>> .el-input-group__append {
  border: 0;
  background: transparent;
}

.search >>> .el-input__inner {
  border: 0;
  background: transparent;
}

.search >>> .input_style {
  border-radius: 40px;
  background: #f2f3f4;
  border: 1px solid #e2e3e4;
}

.othen_search {
  margin: 5px 0 0;
}

.othen_search {
  display: flex;
  flex-wrap: wrap;
}
.othen_search .news_source {
  padding: 10px 5px;
}
.to_txt {
  font-size: 14px;
  color: #4e5671;
}

.date_search {
  margin-bottom: 10px;
}

.othen_search .item_submit {
  cursor: pointer;
  width: 74px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  color:#fff;
  background-color: #0078ff;
  border-radius: 2px;
}

.date_search >>> .el-input {
  width: 120px;
}

.date_search >>> .el-input__inner,
.date_search >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.item_title {
  display: inline-block;
  font-size: 14px;
  color: #4e5671;
  font-family: RCB;
  margin-right: 10px;
}

.news_source >>> .news_input {
  display: inline-block;
  width: 270px;
}

.news_source >>> .el-input__inner,
.news_source >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.data_list >>> .el-pagination {
  margin: 0 auto;
  text-align: center;
}
.news_source >>> .el-select > .el-input {
  width: 150px !important;
}
.date_search >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px !important;
}
.date_search >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.news_source >>> .news_input {
  display: inline-block;
  width: 270px;
}

.news_source >>> .el-input__inner,
.news_source >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.news {
  height: 168px;
  border-bottom: 1px solid #f3f4f5;
}

.news > div {
  display: inline-block;
  vertical-align: top;
}

.news_img {
  width: 145px;
  margin: 30px 0 15px;
  text-align: center;
}

.news_content {
  padding-top: 27px;
  width: calc(100% - 145px);
}

.img_container {
  width: 120px;
  height: 78px;
  line-height: 73px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
}

.img_container img {
  max-width: 100%;
}

.news .news_content .title {
  font-size: 18px;
  color: #9ca2b3;
  font-family: RCB;
  margin-bottom: 15px;
  cursor: pointer;
}

.news .news_content .title:hover {
  color: #4e5671;
}

.news .color_alone {
  color: #1a6bc5;
  font-family: RCR;
}
.item_detail {
  font-family: RCR;
  padding-right: 10px;
}
.news .news_content .detail {
  font-size: 13px;
  color: #6c757d;
  line-height: 20px;
  margin-bottom: 15px;
  font-family: RCR;
}
.other_info > div {
  display: inline-block;
  vertical-align: middle;
  font-size: 12px;
  color: #6c757d;
}
/* .judge_btn {
  width: 40%;
  text-align: right;
} */
.show_btn {
  display: inline-block;
  border: 1px solid #ccc;
  padding: 1px 10px;
  border-radius: 7px;
  font-size: 10px;
}
.publish_media {
  width: 80%;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
  vertical-align: bottom;
}
.publish_media .item_detail {
  cursor: pointer;
}
.item_title .same {
  width: 20%;
}
</style>
